import { useEffect, useState } from "react";
import { api } from "../api";
import type { Run } from "../../server/types";

function fmt(ts: number | null): string {
  if (!ts) return "—";
  return new Date(ts).toLocaleString();
}
function fmtSize(bytes: number | null | undefined): string {
  if (bytes == null) return "—";
  const units = ["B", "KB", "MB", "GB", "TB"];
  let v = bytes; let i = 0;
  while (v >= 1024 && i < units.length - 1) { v /= 1024; i++; }
  return `${v.toFixed(v >= 100 ? 0 : 1)} ${units[i]}`;
}
function fmtDuration(start: number, end: number | null): string {
  if (!end) return "running…";
  const ms = end - start;
  if (ms < 1000) return `${ms}ms`;
  if (ms < 60_000) return `${(ms / 1000).toFixed(1)}s`;
  return `${(ms / 60_000).toFixed(1)}m`;
}

export default function RunsPage() {
  const [runs, setRuns] = useState<Run[]>([]);
  const [err, setErr] = useState<string | null>(null);
  const [selected, setSelected] = useState<Run | null>(null);

  async function refresh() {
    try { setRuns((await api.getRuns(200)).runs); }
    catch (e) { setErr((e as Error).message); }
  }
  useEffect(() => { void refresh(); const t = setInterval(refresh, 5000); return () => clearInterval(t); }, []);

  return (
    <>
      <h2>Runs</h2>
      {err && <div className="error-box" style={{ marginBottom: 16 }}>{err}</div>}

      <div className="card" style={{ padding: 0 }}>
        <table>
          <thead>
            <tr>
              <th>#</th><th>Tier</th><th>Started</th><th>Duration</th>
              <th>Status</th><th>Size</th><th>Lag</th><th></th>
            </tr>
          </thead>
          <tbody>
            {runs.length === 0 && <tr><td colSpan={8} className="muted" style={{ padding: 24, textAlign: "center" }}>No runs yet.</td></tr>}
            {runs.map((r) => (
              <tr key={r.id} onClick={() => setSelected(r)} style={{ cursor: "pointer" }}>
                <td>#{r.id}</td>
                <td><span className={`badge ${r.tier}`}>{r.tier}</span></td>
                <td>{fmt(r.started_at)}</td>
                <td>{fmtDuration(r.started_at, r.finished_at)}</td>
                <td><span className={`badge ${r.status}`}>{r.status}</span></td>
                <td>{fmtSize(r.bytes_uploaded)}</td>
                <td>{r.lag_seconds == null ? "—" : `${r.lag_seconds.toFixed(2)}s`}</td>
                <td>{r.schedule_id ? <span className="muted">scheduled</span> : <span className="muted">manual</span>}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selected && (
        <div className="card">
          <h3>Run #{selected.id} details</h3>
          <div className="kv">
            <div className="k">Tier</div><div><span className={`badge ${selected.tier}`}>{selected.tier}</span></div>
            <div className="k">Status</div><div><span className={`badge ${selected.status}`}>{selected.status}</span></div>
            <div className="k">Started</div><div>{fmt(selected.started_at)}</div>
            <div className="k">Finished</div><div>{fmt(selected.finished_at)}</div>
            <div className="k">Bytes</div><div>{fmtSize(selected.bytes_uploaded)}</div>
            <div className="k">Lag</div><div>{selected.lag_seconds == null ? "—" : `${selected.lag_seconds.toFixed(2)}s`}</div>
            <div className="k">S3 keys</div>
            <div>{selected.s3_keys.length === 0 ? "—" : selected.s3_keys.map((k) => <div key={k}><code>{k}</code></div>)}</div>
            {selected.error && (<>
              <div className="k">Error</div>
              <div><pre style={{ whiteSpace: "pre-wrap", color: "var(--danger)" }}>{selected.error}</pre></div>
            </>)}
          </div>
          <div style={{ marginTop: 12 }}><button onClick={() => setSelected(null)}>Close</button></div>
        </div>
      )}
    </>
  );
}
